import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { constant } from "./constant.js";
import { RuntimeError } from "./errors.js";
import { identity } from "./identity.js";
import { rethrow } from "./rethrow.js";
import { Variable, TYPE_DUPLICATE, TYPE_IMPLICIT, TYPE_NORMAL, no_observer, variable_stale } from "./variable.js";
export var variable_variable = Symbol("variable");
export var variable_invalidation = Symbol("invalidation");
export var variable_visibility = Symbol("visibility");
export function Module(runtime) {
  var builtins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  Object.defineProperties(this, {
    _runtime: {
      value: runtime
    },
    _scope: {
      value: new Map()
    },
    _builtins: {
      value: new Map([["@variable", variable_variable], ["invalidation", variable_invalidation], ["visibility", variable_visibility]].concat(_toConsumableArray(builtins)))
    },
    _source: {
      value: null,
      writable: true
    }
  });
}
Object.defineProperties(Module.prototype, {
  _resolve: {
    value: module_resolve,
    writable: true,
    configurable: true
  },
  redefine: {
    value: module_redefine,
    writable: true,
    configurable: true
  },
  define: {
    value: module_define,
    writable: true,
    configurable: true
  },
  derive: {
    value: module_derive,
    writable: true,
    configurable: true
  },
  import: {
    value: module_import,
    writable: true,
    configurable: true
  },
  value: {
    value: module_value,
    writable: true,
    configurable: true
  },
  variable: {
    value: module_variable,
    writable: true,
    configurable: true
  },
  builtin: {
    value: module_builtin,
    writable: true,
    configurable: true
  }
});

function module_redefine(name) {
  var v = this._scope.get(name);

  if (!v) throw new RuntimeError("".concat(name, " is not defined"));
  if (v._type === TYPE_DUPLICATE) throw new RuntimeError("".concat(name, " is defined more than once"));
  return v.define.apply(v, arguments);
}

function module_define() {
  var v = new Variable(TYPE_NORMAL, this);
  return v.define.apply(v, arguments);
}

function module_import() {
  var v = new Variable(TYPE_NORMAL, this);
  return v.import.apply(v, arguments);
}

function module_variable(observer) {
  return new Variable(TYPE_NORMAL, this, observer);
}

function module_value(_x) {
  return _module_value.apply(this, arguments);
} // If the variable is redefined before its value resolves, try again.


function _module_value() {
  _module_value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name) {
    var v;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            v = this._scope.get(name);

            if (v) {
              _context.next = 3;
              break;
            }

            throw new RuntimeError("".concat(name, " is not defined"));

          case 3:
            if (!(v._observer === no_observer)) {
              _context.next = 14;
              break;
            }

            v = this.variable(true).define([name], identity);
            _context.prev = 5;
            _context.next = 8;
            return module_revalue(this._runtime, v);

          case 8:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            v.delete();
            return _context.finish(9);

          case 12:
            _context.next = 15;
            break;

          case 14:
            return _context.abrupt("return", module_revalue(this._runtime, v));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[5,, 9, 12]]);
  }));
  return _module_value.apply(this, arguments);
}

function module_revalue(_x2, _x3) {
  return _module_revalue.apply(this, arguments);
}

function _module_revalue() {
  _module_revalue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(runtime, variable) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return runtime._compute();

          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return variable._promise;

          case 5:
            return _context2.abrupt("return", _context2.sent);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);

            if (!(_context2.t0 === variable_stale)) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", module_revalue(runtime, variable));

          case 12:
            throw _context2.t0;

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 8]]);
  }));
  return _module_revalue.apply(this, arguments);
}

function module_derive(injects, injectModule) {
  var map = new Map();
  var modules = new Set();
  var copies = []; // Given a module, derives an alias of that module with an initially-empty
  // definition. The variables will be copied later in a second pass below.

  function alias(source) {
    var target = map.get(source);
    if (target) return target;
    target = new Module(source._runtime, source._builtins);
    target._source = source;
    map.set(source, target);
    copies.push([target, source]);
    modules.add(source);
    return target;
  } // Inject the given variables as reverse imports into the derived module.


  var derive = alias(this);

  var _iterator = _createForOfIteratorHelper(injects),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var inject = _step.value;

      var _ref7 = _typeof(inject) === "object" ? inject : {
        name: inject
      },
          _alias = _ref7.alias,
          _name = _ref7.name;

      derive.import(_name, _alias == null ? _name : _alias, injectModule);
    } // Iterate over all the variables (currently) in this module. If any
    // represents an import-with (i.e., an import of a module with a _source), the
    // transitive import-with must be copied, too, as direct injections may affect
    // transitive injections. Note that an import-with can only be created with
    // module.derive and hence it’s not possible for an import-with to be added
    // later; therefore we only need to apply this check once, now.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(modules),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var module = _step2.value;

      var _iterator4 = _createForOfIteratorHelper(module._scope),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ref10 = _step4.value;

          var _ref9 = _slicedToArray(_ref10, 2);

          var _name2 = _ref9[0];
          var variable = _ref9[1];

          if (variable._definition === identity) {
            // import
            if (module === this && derive._scope.has(_name2)) continue; // overridden by injection

            var importedModule = variable._inputs[0]._module;
            if (importedModule._source) alias(importedModule);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    } // Finally, with the modules resolved, copy the variable definitions.

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  for (var _i2 = 0, _copies = copies; _i2 < _copies.length; _i2++) {
    var _ref3 = _copies[_i2];

    var _ref2 = _slicedToArray(_ref3, 2);

    var target = _ref2[0];
    var source = _ref2[1];

    var _iterator3 = _createForOfIteratorHelper(source._scope),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _ref6 = _step3.value;

        var _ref5 = _slicedToArray(_ref6, 2);

        var name = _ref5[0];
        var sourceVariable = _ref5[1];

        var targetVariable = target._scope.get(name);

        if (targetVariable && targetVariable._type !== TYPE_IMPLICIT) continue; // preserve injection

        if (sourceVariable._definition === identity) {
          // import
          var sourceInput = sourceVariable._inputs[0];
          var sourceModule = sourceInput._module;
          target.import(sourceInput._name, name, map.get(sourceModule) || sourceModule);
        } else {
          // non-import
          target.define(name, sourceVariable._inputs.map(variable_name), sourceVariable._definition);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return derive;
}

function module_resolve(name) {
  var variable = this._scope.get(name),
      value;

  if (!variable) {
    variable = new Variable(TYPE_IMPLICIT, this);

    if (this._builtins.has(name)) {
      variable.define(name, constant(this._builtins.get(name)));
    } else if (this._runtime._builtin._scope.has(name)) {
      variable.import(name, this._runtime._builtin);
    } else {
      try {
        value = this._runtime._global(name);
      } catch (error) {
        return variable.define(name, rethrow(error));
      }

      if (value === undefined) {
        this._scope.set(variable._name = name, variable);
      } else {
        variable.define(name, constant(value));
      }
    }
  }

  return variable;
}

function module_builtin(name, value) {
  this._builtins.set(name, value);
}

function variable_name(variable) {
  return variable._name;
}